<template>
  <div v-if="datasource.length > 0" :style="divStyle">
    <span v-if="!readonly && tabList" :style="titleStyle">{{ tabList.processNm }}</span>
    <v-expansion-panels v-model="expandedPanel" accordion :class="{ 'mt-3': !readonly }">
      <v-expansion-panel v-for="(row, i) in datasource" :key="i">
        <v-expansion-panel-header
          v-bind:color="titleColorList[i] ? titleColorList[i].color : 'defaultColor'"
          @click="titleClick(i)"
        >
          <v-row no-gutters align="center">
            <v-col cols="8">
              <!-- Main Titile -->
              <v-text-field v-if="row.__created__" :style="mainStyle" v-model="row.workNm" />
              <span v-else :style="mainStyle">{{ row.workNm }}</span>
            </v-col>
            <v-col cols="4" align="center">
              <span :style="mainStyle">(감소대책:{{ row.count }} / 유해위험요인:{{ row.cnt }})</span>
              <v-tooltip right color="primary" max-width="300px">
                <template v-slot:activator="{ on }">
                  <span>
                    <svg-icon icon-class="info" style="height: 1rem" v-on="on" />
                  </span>
                </template>
                <div class="tooltip-text">{{ '해당 항목은 저장 후 갱신됩니다.' }}</div>
              </v-tooltip>
            </v-col>
          </v-row>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <!-- 작업공정 안전보건정보 작성 -->
          <template v-if="workDetailList && workDetailList.length > 0">
            <v-card v-for="(row, index) in workDetailList" :key="index" width="100%">
              <v-card class="mt-2 pa-4 panel-inner">
                <v-row no-gutters class="mb-2" style="background-color: #56a4ff; color:white;">
                  <v-card width="100%" class="d-flex align-center justify-center ma-2"></v-card>
                </v-row>
                <v-row no-gutters>
                  <v-col v-if="row.__updated__" cols="12" class="d-flex align-center">
                    <div
                      style="border-radius: 10px; background-color: #f0ad4e; width: 11px; height: 11px;"
                    ></div>
                    <span class="pl-2">수정중인 항목</span>
                  </v-col>
                </v-row>
                <span class="editor-title">작업내용</span>
                <!-- 평가일자 -->
                <v-row no-gutters>
                  <v-col cols="3" class="pr-3">
                    <span class="editor-label">평가일자</span>

                    <v-text-field
                      :value="formatDate(row.doDt)"
                      readonly
                      hide-details
                      append-icon="mdi-calendar"
                      class="editor_bg"
                      solo
                      style="width: 100%;"
                    ></v-text-field>
                  </v-col>
                  <!-- 평가구분 -->
                  <v-col cols="3" class="px-1">
                    <span class="editor-label">평가구분</span>

                    <v-text-field
                      v-model="row.riskFactorDivNm"
                      readonly
                      hide-details
                      class="editor_bg"
                      solo
                      style="width: 100%;"
                    ></v-text-field>
                  </v-col>

                  <!-- 사고발생시 피해예상자 -->
                  <v-col cols="6" class="pl-3">
                    <span class="editor-label">사고발생시 피해예상자</span>
                    <div class="mt-2">
                      <v-tooltip bottom v-for="(i, indexVi) in row.victims" :key="indexVi">
                        <template v-slot:activator="{ on }">
                          <v-chip v-on="on" class="mr-2">
                            <v-icon left>mdi-account</v-icon>
                            {{ i.victimNm }}
                          </v-chip>
                        </template>
                        <div v-html="i.victimNm"></div>
                      </v-tooltip>
                    </div>
                  </v-col>
                </v-row>

                <!-- 유해위험요인 -->
                <v-row no-gutters class="mt-5">
                  <v-col cols="12">
                    <span class="editor-label">유해위험요인 파악</span>
                    <v-text-field v-model="row.riskFactorContent" readonly class="editor_bg" solo></v-text-field>
                  </v-col>
                </v-row>

                <!-- 위험성 평가 -->
                <v-row no-gutters class="mt-5">
                  <v-col cols="12">
                    <span
                      class="editor-label"
                    >위험성 평가 (위험성 평가 기법: {{ dataSetList[0].riskEstimationSetting[dataSetList[0].riskEstimation].minorNm }})</span>
                    <v-row no-gutters>
                      <v-col cols="6" class="pr-1">
                        <v-simple-table v-if="dataSetList[0].riskEstimation" class="custom-table">
                          <template
                            v-if="dataSetList[0].riskEstimation === '00002' && dataSetList[0].riskEstimationSetting[dataSetList[0].riskEstimation]"
                          >
                            <tr>
                              <td class="text-center tableTitle" colspan="3">현재 위험성</td>
                            </tr>
                            <tr>
                              <td class="text-center tableTitle">{{ getHeaderValue('high') }}</td>
                              <td class="text-center tableTitle">{{ getHeaderValue('middle') }}</td>
                              <td class="text-center tableTitle">{{ getHeaderValue('lower') }}</td>
                            </tr>
                            <tr :key="tableComponentKey">
                              <td>
                                <v-radio-group
                                  v-model="row.riskEstimationVal1"
                                  row
                                  style="display:flex; justify-content:center !important;"
                                >
                                  <v-radio
                                    color="radio"
                                    v-model="dataSetList[0].riskEstimationSetting[dataSetList[0].riskEstimation].data[0].minorCd"
                                    style="margin-left: 16px !important;"
                                    disabled
                                  ></v-radio>
                                </v-radio-group>
                              </td>
                              <td>
                                <v-radio-group
                                  v-model="row.riskEstimationVal1"
                                  row
                                  style="display:flex; justify-content:center !important;"
                                >
                                  <v-radio
                                    color="radio"
                                    v-model="dataSetList[0].riskEstimationSetting[dataSetList[0].riskEstimation].data[1].minorCd"
                                    style="margin-left: 16px !important;"
                                    disabled
                                  ></v-radio>
                                </v-radio-group>
                              </td>
                              <td>
                                <v-radio-group
                                  v-model="row.riskEstimationVal1"
                                  row
                                  style="display:flex; justify-content:center !important;"
                                >
                                  <v-radio
                                    color="radio"
                                    v-model="dataSetList[0].riskEstimationSetting[dataSetList[0].riskEstimation].data[2].minorCd"
                                    style="margin-left: 16px !important;"
                                    disabled
                                  ></v-radio>
                                </v-radio-group>
                              </td>
                            </tr>
                          </template>
                          <template v-else>
                            <tr>
                              <td class="text-center tableTitle" colspan="3">현재 위험성</td>
                            </tr>
                            <tr>
                              <td class="text-center tableTitle">빈도</td>
                              <td class="text-center tableTitle">강도</td>
                              <td class="text-center tableTitle">위험성</td>
                            </tr>
                            <tr :key="tableComponentKey">
                              <td class="text-center">{{ row.riskEstimationNum1 }}</td>
                              <td class="text-center">{{ row.riskEstimationNum2 }}</td>
                              <td class="text-center" style="width:110px;">{{ getRiskLevel(row) }}</td>
                            </tr>
                          </template>
                        </v-simple-table>
                      </v-col>
                      <v-col cols="6" class="pl-1">
                        <v-simple-table v-if="dataSetList[0].riskEstimation" class="custom-table">
                          <template
                            v-if="dataSetList[0].riskEstimation === '00002' && dataSetList[0].riskEstimationSetting[dataSetList[0].riskEstimation]"
                          >
                            <tr>
                              <td class="text-center tableTitle required" colspan="3">개선 후 위험성 수준</td>
                            </tr>
                            <tr>
                              <td class="text-center tableTitle">{{ getHeaderValue('high') }}</td>
                              <td class="text-center tableTitle">{{ getHeaderValue('middle') }}</td>
                              <td class="text-center tableTitle">{{ getHeaderValue('lower') }}</td>
                            </tr>
                            <tr :key="tableComponentKey">
                              <td>
                                <v-radio-group
                                  v-model="row.riskEstimationAfterVal1"
                                  row
                                  style="display:flex; justify-content:center !important;"
                                  @change="riskLevelValueChanged(row)"
                                >
                                  <v-radio
                                    color="radio"
                                    v-model="dataSetList[0].riskEstimationSetting[dataSetList[0].riskEstimation].data[0].minorCd"
                                    style="margin-left: 16px !important;"
                                  ></v-radio>
                                </v-radio-group>
                              </td>
                              <td>
                                <v-radio-group
                                  v-model="row.riskEstimationAfterVal1"
                                  row
                                  style="display:flex; justify-content:center !important;"
                                  @change="riskLevelValueChanged(row)"
                                >
                                  <v-radio
                                    color="radio"
                                    v-model="dataSetList[0].riskEstimationSetting[dataSetList[0].riskEstimation].data[1].minorCd"
                                    style="margin-left: 16px !important;"
                                  ></v-radio>
                                </v-radio-group>
                              </td>
                              <td>
                                <v-radio-group
                                  v-model="row.riskEstimationAfterVal1"
                                  row
                                  style="display:flex; justify-content:center !important;"
                                  @change="riskLevelValueChanged(row)"
                                >
                                  <v-radio
                                    color="radio"
                                    v-model="dataSetList[0].riskEstimationSetting[dataSetList[0].riskEstimation].data[2].minorCd"
                                    style="margin-left: 16px !important;"
                                  ></v-radio>
                                </v-radio-group>
                              </td>
                            </tr>
                          </template>
                          <template v-else>
                            <tr>
                              <td colspan="3" class="text-center tableTitle required">개선 후 위험성 수준</td>
                            </tr>
                            <tr>
                              <td class="text-center tableTitle">빈도</td>
                              <td class="text-center tableTitle">강도</td>
                              <td class="text-center tableTitle">위험성</td>
                            </tr>
                            <tr :key="tableComponentKey">
                              <td class="text-center">
                                <v-select
                                  v-model="row.riskEstimationAfterVal1"
                                  :items="dataSetList[0].freqList"
                                  item-text="minorNm"
                                  item-value="minorCd"
                                  solo
                                  class="editor_bg"
                                  :readonly="readonly"
                                  @change="riskLevelValueChanged(row)"
                                >
                                  <template v-slot:selection="{ item }">
                                    <div class="text-center">{{ item.minorNm }}</div>
                                  </template>
                                  <template v-slot:item="{ item }">
                                    <v-list-item-content>
                                      <v-list-item-title>{{ item.minorNm }}</v-list-item-title>
                                    </v-list-item-content>
                                  </template>
                                </v-select>
                              </td>
                              <td class="text-center">
                                <v-select
                                  v-model="row.riskEstimationAfterVal2"
                                  :items="dataSetList[0].strengthList"
                                  item-text="minorNm"
                                  item-value="minorCd"
                                  solo
                                  class="editor_bg"
                                  :readonly="readonly"
                                  @change="riskLevelValueChanged(row)"
                                >
                                  <template v-slot:selection="{ item }">
                                    <div class="text-center">{{ item.minorNm }}</div>
                                  </template>
                                  <template v-slot:item="{ item }">
                                    <v-list-item-content>
                                      <v-list-item-title>{{ item.minorNm }}</v-list-item-title>
                                    </v-list-item-content>
                                  </template>
                                </v-select>
                              </td>
                              <td
                                class="text-center"
                                style="width:110px;"
                              >{{ getRiskAfterLevel(row) }}</td>
                            </tr>
                          </template>
                        </v-simple-table>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
                <v-divider class="mt-5" />
                <!-- 근로자 의견 -->
                <v-row no-gutters class="mt-5">
                  <v-col cols="12">
                    <expansionPanelList
                      v-if="row.comments"
                      :subTitle="`근로자 의견 (${row.comments.length ? row.comments.length : 0})`"
                      :datasource="row.comments"
                    />
                  </v-col>
                </v-row>

                <v-divider class="mt-5" />

                <!-- 감소대책 -->
                <p class="editor-title mt-5">감소대책</p>
                <template v-if="row.reduction.length > 0">
                  <v-card
                    no-gutters
                    v-for="(item, indexRed) in row.reduction"
                    :key="indexRed"
                    class="mt-5 addable-card d-flex"
                  >
                    <div v-if="!readonly && item.actDt == null" class="addable-left">
                      <!-- 삭제 버튼 -->
                      <v-btn
                        text
                        @click="removeWork(index, indexRed)"
                        height="calc(100% - 24px)"
                        class="rounded-pill ma-3 pa-2"
                        :color="'error'"
                      >
                        <svg-icon icon-class="minus" style="height:20px" />
                      </v-btn>
                    </div>
                    <v-card width="100%" class="pa-4 addable-contents">
                      <v-row no-gutters>
                        <v-col v-if="item.__created__" cols="12" class="d-flex align-center">
                          <div
                            style="border-radius: 10px; background-color: #6df6ea; width: 11px; height: 11px;"
                          ></div>
                          <span class="pl-2">신규 항목</span>
                        </v-col>
                        <v-col
                          v-if="!item.__created__ && item.__updated__"
                          cols="12"
                          class="d-flex align-center"
                        >
                          <div
                            style="border-radius: 10px; background-color: #f0ad4e; width: 11px; height: 11px;"
                          ></div>
                          <span class="pl-2">수정중인 항목</span>
                        </v-col>
                        <v-col v-if="item.actDt" cols="12" class="d-flex align-center">
                          <div
                            style="border-radius: 10px; background-color: #ff0000; width: 11px; height: 11px;"
                          ></div>
                          <span class="pl-2">이행 완료된 항목</span>
                        </v-col>
                      </v-row>
                      <v-row no-gutters>
                        <v-col cols="6">
                          <span class="editor-label required">개선 예정일</span>
                          <v-menu
                            :ref="row.menuStDate +'_'+ indexRed + '_' + row.riskReduceMeasuresId"
                            :value="item.menuStDate"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            :min-width="100"
                            :disabled="readonly || item.actDt != null"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                :value="formatDate(item.planDt)"
                                append-icon="mdi-calendar"
                                readonly
                                v-bind="attrs"
                                v-on="on"
                                solo
                                class="editor_bg"
                              ></v-text-field>
                            </template>
                            <v-date-picker
                              v-model="item.planDt"
                              no-title
                              scrollable
                              @input="item.menuStDate = false"
                              @change="updateItem(row, item)"
                            ></v-date-picker>
                          </v-menu>
                        </v-col>
                        <v-col cols="12">
                          <span class="editor-label required">감소대책</span>
                          <v-textarea
                            solo
                            class="editor_bg"
                            clearable
                            no-resize
                            auto-grow
                            spellcheck="false"
                            clear-icon="mdi-close-circle-outline"
                            rows="3"
                            row-height="30"
                            placeholder="감소 대책을 작성 해 주세요."
                            v-model="item.riskReduceMeasuresContent"
                            :disabled="readonly || item.actDt != null"
                            @input="updateItem(row, item)"
                          ></v-textarea>
                        </v-col>
                      </v-row>

                      <v-simple-table class="mt-5 custom-table">
                        <template v-slot:default>
                          <tbody>
                            <tr>
                              <td class="text-center tableTitle required" style="width: 15%">담당자</td>
                              <td>
                                <v-tooltip
                                  bottom
                                  v-for="(idx, indexPer) in item.person"
                                  :key="`${idx.esgHrNo}_${indexPer}_${tableComponentKey}`"
                                >
                                  <template v-slot:activator="{ on }">
                                    <v-chip
                                      v-if="readonly || item.actDt != null"
                                      v-on="on"
                                      class="mr-2 my-1"
                                    >
                                      <v-icon left>mdi-account</v-icon>
                                      {{ idx.korNm }}
                                    </v-chip>
                                    <v-chip
                                      v-else
                                      v-on="on"
                                      class="mr-2 my-1"
                                      close
                                      @click:close="chipClose(index, indexRed, indexPer)"
                                    >
                                      <v-icon left>mdi-account</v-icon>
                                      {{ idx.korNm }}
                                    </v-chip>
                                  </template>
                                  <div v-html="idx.grpAuthNm"></div>
                                </v-tooltip>
                                <v-btn
                                  v-if="!readonly && item.actDt == null"
                                  x-small
                                  class="pa-0 float-right my-2"
                                  icon
                                  @click="hrInfoPopupOpen(index, indexRed)"
                                >
                                  <svg-icon style="height:18px; color:#9BA4AC;" icon-class="search"></svg-icon>
                                </v-btn>
                              </td>
                            </tr>
                          </tbody>
                        </template>
                      </v-simple-table>
                    </v-card>
                    <hrSelect
                      v-if="!readonly"
                      :popupVisible="hrInfoPopupVisible"
                      @popupClose="hrInfoPopupVisible = false"
                      title="담당자 설정"
                      :id="personInfo"
                      :company="item.clntId"
                      :selectedHrs="personList"
                      @apply="apply"
                      :mode="'multi'"
                    />
                  </v-card>
                </template>
                <v-card v-else height="100%">
                  <div class="grey--text d-flex justify-center align-center">감소대책이 없습니다.</div>
                </v-card>
                <!-- 감소대책 추가 버튼 -->
                <template v-if="!readonly">
                  <v-btn
                    elevation="0"
                    @click="addWork(index)"
                    width="100%"
                    height="48"
                    class="table-add-btn mt-5"
                  >
                    <svg-icon icon-class="table-add" style="height: 20px" />
                  </v-btn>
                </template>
              </v-card>
            </v-card>
          </template>

          <v-card v-else class="mt-4">
            <p class="grey--text d-flex justify-center my-16">데이터가 없습니다.</p>
          </v-card>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
  <h3 v-else class="grey--text d-flex justify-center my-16">데이터가 없습니다.</h3>
</template>

<script>
import notify from 'devextreme/ui/notify'
// utils
import { getCurrentDate } from '@/utils/common.js'
import { getCommonCode } from '@/api/common/commonApi'
//컴포넌트
import hrSelect from '@/components/common/hrSelect.vue'
import expansionPanelList from '@/components/esgCommon/expansionPanelList.vue'

export default {
  components: {
    hrSelect,
    expansionPanelList
  },
  name: 'reductionPanelTreeProcess',
  props: {
    tabList: {
      type: Object,
      default: () => {}
    },
    assessmentKey: {
      type: Number,
      default: 0
    },
    datasource: {
      type: Array,
      default: () => []
    },
    dataSetList: {
      type: Array,
      default: () => []
    },
    workDetailList: {
      type: Array,
      default: () => []
    },
    headerDefaultColor: {
      type: String,
      default: '#fff'
    },
    headerExpandedColor: {
      type: String,
      default: '#fff'
    },
    titleStyle: {
      type: String,
      default: 'font-size: 1.2rem; font-weight: 700'
    },
    mainStyle: {
      type: String,
      default: 'font-size: 1rem; font-weight: 600'
    },
    sub1Style: {
      type: String,
      default: 'font-size: 1rem; font-weight: 400;'
    },
    sub2Style: {
      type: String,
      default: 'font-size: 1rem; font-weight: 400'
    },
    textStyle: {
      type: String,
      default: 'font-size: medium;'
    },
    divStyle: {
      type: String,
      default: ''
    },
    firstDataExpand: {
      type: Boolean,
      default: false
    },
    searchProcess: {
      type: String,
      default: ''
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      hrInfoPopupVisible: false,
      expandedPanel: [],
      test: false,
      titleColorList: [],
      rules: '',
      //위험성 추정 기준
      color: 'grey',
      deletList: [],
      personList: [],
      tableComponentKey: 0,
      personInfo: '',
      menuStDate: false,
      riskValueGroup: []
    }
  },
  watch: {
    datasource() {
      this.titleColorList = []
      this.datasource.forEach(row => {
        let defaultColor = {
          color: this.headerDefaultColor
        }
        this.titleColorList.push(defaultColor)
      })
      //패널 초기화
      if (!this.readonly && (this.assessmentKey || this.assessmentKey == 0)) {
        // let index = this.datasource.findIndex(element => element.processId == this.searchProcess)
        let index = this.assessmentKey
        this.expandedPanel = index

        if (this.titleColorList[index]) {
          this.titleColorList[index].color = this.headerExpandedColor
        } else {
          this.titleColorList[index] = { color: this.headerExpandedColor }
        }
      }
    },
    workDetailList() {
      //현재날짜 세팅
      this.workDetailList.forEach(row => {
        /* 화면상 데이터, 출력물 데이터가 상이하여 개선 후 위험성 수준 디폴트 세팅 주석 처리(2024.05.30 LJH ) */

        // row.menuStDate가 비어 있는 경우 현재 날짜를 할당
        // if (row.riskEstimationVal1 && !row.riskEstimationAfterVal1) {
        //   row.riskEstimationAfterVal1 = row.riskEstimationVal1
        //   row.riskEstimationAfterNum1 = row.riskEstimationNum1
        // }
        // if (row.riskEstimationVal2 && !row.riskEstimationAfterVal2) {
        //   row.riskEstimationAfterVal2 = row.riskEstimationVal2
        //   row.riskEstimationAfterNum2 = row.riskEstimationNum2
        // }
        if (row.riskEstimationVal1 && !row.riskEstimationAfterVal1) {
          row.riskEstimationAfterVal1 = null
          row.riskEstimationAfterNum1 = null
        }
        if (row.riskEstimationVal2 && !row.riskEstimationAfterVal2) {
          row.riskEstimationAfterVal2 = null
          row.riskEstimationAfterNum2 = null
        }
        if (!row.doDt) {
          row.doDt = getCurrentDate() // 현재 날짜
        }
        if (row.reduction.length > 0) {
          row.reduction.forEach(el => {
            if (!el.planDt) {
              el.planDt = getCurrentDate()
            }
          })
        }
      })
    }
  },
  computed: {
    mobileTrigger: function() {
      return this.width < 800
    },
    computedClearIcon(actDt) {
      return !this.readonly && actDt == null ? 'mdi-close-circle-outline' : ''
    }
  },
  mounted() {
    this.setData()
    this.datasource.forEach((row, i) => {
      let defaultColor = {
        color: i == 0 && this.firstDataExpand ? this.headerExpandedColor : this.headerDefaultColor
      }
      this.titleColorList.push(defaultColor)
    })

    if (this.firstDataExpand) {
      this.expandedPanel = [0]
    }
  },
  methods: {
    chipClose(index, indexRed, indexPer) {
      this.workDetailList[index].reduction[indexRed].person.splice(indexPer, 1)
      this.tableComponentKey++
      this.updateItem(this.workDetailList[index], this.workDetailList[index].reduction[indexRed])
    },
    getRiskLevel(item) {
      if (this.dataSetList[0].freqValueList.length > 0) {
        let data = this.dataSetList[0].freqValueList.find(el => el.minorCd == item.riskEstimationNum1 * item.riskEstimationNum2)
        return data ? data.minorNm : ''
      }
      return ''
    },
    getRiskAfterLevel(item) {
      let value1 = this.dataSetList[0].riskEstimationValue.find(el => el.minorCd == item.riskEstimationAfterVal1)
      let value2 = this.dataSetList[0].riskEstimationValue.find(el => el.minorCd == item.riskEstimationAfterVal2)

      if (value1 && value2) {
        item.riskEstimationAfterNum1 = value1.extra3
        item.riskEstimationAfterNum2 = value2.extra3
      }
      if (this.dataSetList[0].freqValueList.length > 0) {
        let data = this.dataSetList[0].freqValueList.find(el => el.minorCd == item.riskEstimationAfterNum1 * item.riskEstimationAfterNum2)
        return data ? data.minorNm : ''
      }
      return ''
    },
    hrInfoPopupOpen(index, indexRed) {
      let item = this.workDetailList[index].reduction[indexRed]
      this.personInfo = index + '_' + indexRed + '_' + item.workId + '_' + item.riskFactorId + '_' + item.riskReduceMeasuresId
      this.personList = []
      if (item.person) {
        item.person.forEach(el => {
          if (el.workId === item.workId && el.riskFactorId === item.riskFactorId && el.riskReduceMeasuresId === item.riskReduceMeasuresId) {
            this.personList.push(el)
          }
        })
      } else {
        this.personList = []
      }
      this.hrInfoPopupVisible = true
    },
    apply(e) {
      const [index, indexRed, workId, riskFactorId, riskReduceMeasuresId] = this.personInfo.split('_')
      //쪼개야함!!
      let data = {
        index: index,
        indexRed: indexRed,
        workId: workId,
        riskFactorId: riskFactorId,
        riskReduceMeasuresId: riskReduceMeasuresId
      }
      if (this.workDetailList[data.index].reduction && this.workDetailList[data.index].reduction.length > 0) {
        this.workDetailList[data.index].reduction[indexRed].person = e
      }
      this.hrInfoPopupVisible = false
      this.tableComponentKey++
      this.updateItem(this.workDetailList[data.index], this.workDetailList[data.index].reduction[indexRed])
    },

    riskEstimationChanged() {
      // 허용가능한 위험성 기준 값 변경
      if (this.dataSetList[0].riskEstimation === '00002') {
        this.datasource.riskEstimationAfterVal1 = 'f_3'
        this.datasource.riskEstimationAfterVal1 = 's_3'
      } else if (this.dataSetList[0].riskEstimation === '00001') {
        this.datasource.riskEstimationAfterVal1 = 'middle'
      }
    },
    titleClick(index) {
      // if (this.workDetailList[index].reduction.length > 0) {
      //   this.workDetailList[index].reduction.forEach(el => {
      //     if (el.person.length > 0) {
      //       console.log('인원', el.person)
      //     }
      //   })
      // }
      if (this.titleColorList[index].color === this.headerDefaultColor) {
        this.titleColorList[index].color = this.headerExpandedColor
        this.titleColorList.forEach(element => {
          if (element != this.titleColorList[index]) element.color = this.headerDefaultColor
        })
      } else {
        this.titleColorList[index].color = this.headerDefaultColor
      }
      this.$emit('titleClick', index)
      this.personData(index)
    },
    personData(index) {
      console.log('this.workDetailList[index]', this.workDetailList[index])
    },
    //추가버튼
    addWork(index) {
      console.log('감소대책추가', index)
      if (this.workDetailList.length < 1) {
        notify(this.$t('위험성평가를 선택해주세요.'), 'warning', 1000)
        return
      }
      let data = this.workDetailList[index]
      const row = {
        clntId: data.clntId,
        compId: data.compId,
        writeDt: data.writeDt,
        docNo: data.docNo,
        constructId: data.constructId,
        processId: data.processId,
        workId: data.workId,
        riskFactorId: data.riskFactorId,
        riskReduceMeasuresId: data.riskFactorId + '_' + this.workDetailList[index].reduction.length.toString(),
        planDt: getCurrentDate(),
        useYn: 'Y',
        person: [],
        __created__: true,
        __updated__: true
      }

      this.workDetailList[index].reduction.push(row)
      this.workDetailList[index].__updated__ = true
    },

    //삭제버튼
    removeWork(index, indexRed) {
      this.workDetailList[index].reduction[indexRed].useYn = 'N'
      console.log('삭제버튼 클릭', this.workDetailList[index].reduction[indexRed])
      if (!this.workDetailList[index].reduction[indexRed].__created__) {
        // 신규데이터 입력 중 삭제는 push하지 않는다.
        this.dataSetList[0].deleteList.push(this.workDetailList[index].reduction[indexRed])
      }
      this.workDetailList[index].reduction.splice(indexRed, 1) // 요소를 삭제합니다.
    },

    getWorksCnt(works) {
      if (works) {
        let list = works.filter(element => !element.__created__)
        return list.length
      }
      return 0
    },
    getUseWorksCnt(works) {
      if (works) {
        let list = works.filter(element => element.useYn == 'Y' && !element.__created__)
        return list.length
      }
      return 0
    },
    getHeaderValue(code) {
      let data = this.riskValueGroup.find(element => element.minorCd == code)
      if (data) {
        let text = `${data.minorNm}(${data.extra3})`
        return text
      }
      return ''
    },
    ///////////////////////////////////////
    /*               Event               */
    ///////////////////////////////////////
    // formatDate(date) {
    //   console.log('1번')
    //   if (!date) return null

    //   if (date.indexOf('-') > -1) {
    //     const [year, month, day] = date.split('-')
    //     return `${year}.${month}.${day}`
    //   } else {
    //     return date
    //   }
    // },
    formatDate(date) {
      if (!date) return null

      if (date.indexOf('-') == -1) {
        const year = date.substring(0, 4)
        const month = date.substring(4, 6)
        const day = date.substring(6, 8)
        return `${year}-${month}-${day}`
      } else if (date.indexOf('-') > -1) {
        const [year, month, day] = date.split('-')
        return `${year}.${month}.${day}`
      } else {
        return date
      }
    },
    updateItem(headRow, item) {
      if (!headRow.__updated__) headRow.__updated__ = true
      if (!item.__updated__) item.__updated__ = true
    },
    setData() {
      Promise.all([getCommonCode('RA002_1')]).then(response => {
        this.riskValueGroup = response[0].list
      })
    },
    riskLevelValueChanged(data) {
      data.__updated__ = true
      this.dataSetList[0].deleteList.push(data)
    }
  }
}
</script>
<style scoped>
.tg {
  margin: 10px 0;
  border-collapse: collapse;
  border-spacing: 0;
}
.tg td {
  border-color: black;
  border-style: solid;
  border-width: 1px;
  font-family: Arial, sans-serif;
  font-size: 14px;
  padding: 10px 5px;
  word-break: normal;
}
.tg th {
  border-color: black;
  border-style: solid;
  border-width: 1px;
  font-family: Arial, sans-serif;
  font-size: 14px;
  font-weight: normal;
  padding: 10px 5px;
  word-break: normal;
}
.tg .tableBk {
  background-color: #f4f5f6;
  text-align: center;
  text-align: bold;
  vertical-align: top;
}
.tg .tg-0pky {
  border-color: inherit;
  text-align: left;
  vertical-align: top;
}
</style>
